<header [class]="themeService.getCombinedClasses()" *ngIf="checkLocation()">
  <div class="container-fluid g-0">
    <div class="header-container" [class]="getHeaderClass()">
      <div class="col-4 header-el" style="justify-content: space-between;">
        <div class="d-flex flex-row align-items-center">
          <app-icon
            [icon]="Icons.logo"
            [invert]="getInvert()"
            [routerLink]="'/'"
            (click)="up(); countryService.setRandom()"
            class="header-container-logo"/>
        </div>
        <div *ngIf="!menuService.getActive()" class="d-flex flex-row align-items-center">
          <app-airport-panel [invert]="getInvert()"/>
        </div>
      </div>
      <div class="col-4 header-el" style="justify-content: center;">
        <div *ngIf="!menuService.getActive()" class="d-flex flex-row align-items-center">
          <app-button>
            <h6 class="px-3 py-1" [routerLink]="'destinations'" (click)="up()">
              <app-texts
                [texts]="[
                {text: ['Направления', 'Destinations']}
              ]"
              />
            </h6>
          </app-button>
          <app-button class="ms-2">
            <h6 class="px-3 py-1" [routerLink]="'adventures'" (click)="up()">
              <app-texts
                [texts]="[
                {text: ['Путешествия', 'Adventures']}
              ]"
              />
            </h6>
          </app-button>
          <app-button class="ms-2">
            <h6 class="px-3 py-1" [routerLink]="'services'" (click)="up()">
              <app-texts
                [texts]="[
                {text: ['Услуги', 'Services']}
              ]"
              />
            </h6>
          </app-button>
        </div>
      </div>
      <div class="col-1"></div>
      <div class="col-3 header-el" [style]="!menuService.getActive()? 'justify-content: space-between;' : 'justify-content: flex-end;'">
        <div *ngIf="!menuService.getActive()" class="d-flex flex-row align-items-center" style="opacity: 0">
          <h6 (click)="openMG()">VIP in Airports</h6>
        </div>
        <div class="d-flex flex-row align-items-center" style="gap: 7px">
          <app-button *ngIf="!menuService.getActive()" class="ms-2 header-text-button" style="font-size: 14px">
            <app-texts
              [texts]="[
                {text: ['Рус', 'Eng']}
              ]"
              [style.color]="interfaceService.getActiveInterface() === 'header-transparent' ? 'white' : 'black'"
              (click)="localizationService.setLanguage()"
              class="mx-3 lang-button"
            />
          </app-button>
          <app-button *ngIf="!menuService.getActive()">
            <app-icon class="px-3 py-1" [icon]="Icons.phone" [invert]="getInvert()" (click)="openWhatsApp()"/>
          </app-button>
          <app-button *ngIf="!menuService.getActive()" [routerLink]="'/feedback'" (click)="up()">
            <app-icon class="px-3 py-1" [icon]="Icons.email" [invert]="getInvert()"/>
          </app-button>
          <app-button *ngIf="menuService.getActive()">
            <app-icon class="px-3 py-1" [icon]="Icons.theme" [invert]="!getInvert()" (click)="themeService.changeTheme()"/>
          </app-button>
<!--          <app-button (click)="menuService.setActive()" class="ms-2">-->
<!--            <app-icon class="px-3 py-1" [icon]="!menuService.getActive() ? Icons.hamburger : Icons.crossBold" [invert]="getInvert()"/>-->
<!--          </app-button>-->
        </div>
      </div>
    </div>
  </div>
</header>
<!--<div class="header-mob-container"-->
<!--     *ngIf="showMobileHeader() && !tabHeaderHide"-->
<!--&gt;-->
<!--  <div class="header-mob-el-container" *ngIf="!menuService.getActive()">-->
<!--      <app-icon [icon]="Icons.phone" [invert]="getInvert()" (click)="openWhatsApp()" class="header-mob-el-button"/>-->
<!--      <app-icon [icon]="Icons.email" [invert]="getInvert()" [routerLink]="'feedback'" (click)="up()" class="header-mob-el-button"/>-->
<!--      <app-icon [icon]="Icons.hamburger" (click)="menuService.setActive()" [invert]="getInvert()" class="header-mob-el-button"/>-->
<!--      <app-icon-->
<!--        *ngIf="this.router.url === '/feedback' && !menuService.getMobileForm()"-->
<!--        [icon]="Icons.thunder"-->
<!--        [invert]="!getInvert()"-->
<!--        (click)="menuService.setMobileForm(!menuService.getMobileForm())"-->
<!--        class="header-mob-el-button"-->
<!--      />-->
<!--    <app-icon-->
<!--      *ngIf="this.router.url === '/feedback' && menuService.getMobileForm()"-->
<!--      [icon]="Icons.crossClose"-->
<!--      [invert]="getInvert()"-->
<!--      (click)="menuService.setMobileForm(!menuService.getMobileForm())"-->
<!--      class="header-mob-el-button"-->
<!--    />-->
<!--      <app-icon-->
<!--        *ngIf="showBackButton('geo') && !interfaceService.getHotelOpenGeo() && !menuService.getActive()"-->
<!--        [icon]="Icons.geoAnchor"-->
<!--        [invert]="getInvert()"-->
<!--        (click)="interfaceService.setHotelOpenGeo(true)"-->
<!--        class="header-mob-el-button"-->
<!--      />-->
<!--      <app-icon-->
<!--        *ngIf="interfaceService.getHotelOpenGeo() && showBackButton('geo') && !menuService.getActive()"-->
<!--        (click)="interfaceService.setHotelOpenGeo(false)"-->
<!--        [icon]="Icons.crossClose"-->
<!--        [invert]="getInvert()"-->
<!--        class="header-mob-el-button"-->
<!--      />-->
<!--      <app-icon-->
<!--        *ngIf="showBackButton('map')"-->
<!--        (click)="openMap()"-->
<!--        [icon]="Icons.mapMob"-->
<!--        [invert]="getInvert()"-->
<!--        class="header-mob-el-button"-->
<!--      />-->
<!--      <app-icon-->
<!--        *ngIf="this.router.url === '/map'"-->
<!--        [icon]="Icons.crossClose"-->
<!--        [invert]="getInvert()"-->
<!--        (click)="navigationService.backOrHome();"-->
<!--        class="header-mob-el-button"-->
<!--      />-->
<!--  </div>-->
<!--&lt;!&ndash;  <div&ndash;&gt;-->
<!--&lt;!&ndash;    *ngIf="showBackButton('back') && !interfaceService.getHotelOpenGeo() && !menuService.getActive()"&ndash;&gt;-->
<!--&lt;!&ndash;    class="header-hotels-button"&ndash;&gt;-->
<!--&lt;!&ndash;    style="left: -76px"&ndash;&gt;-->
<!--&lt;!&ndash;    (click)="stepBack()"&ndash;&gt;-->
<!--&lt;!&ndash;  >&ndash;&gt;-->
<!--&lt;!&ndash;    <app-icon&ndash;&gt;-->
<!--&lt;!&ndash;      [icon]="Icons.arrowDownBlack"&ndash;&gt;-->
<!--&lt;!&ndash;      [invert]="!getInvert()"&ndash;&gt;-->
<!--&lt;!&ndash;      [style.transform]="'rotate(90deg)'"&ndash;&gt;-->
<!--&lt;!&ndash;    />&ndash;&gt;-->
<!--&lt;!&ndash;  </div>&ndash;&gt;-->
<!--&lt;!&ndash;  <div&ndash;&gt;-->
<!--&lt;!&ndash;    class="header-hotels-button"&ndash;&gt;-->
<!--&lt;!&ndash;    style="right: -76px"&ndash;&gt;-->
<!--&lt;!&ndash;    *ngIf="showBackButton('geo') && !interfaceService.getHotelOpenGeo() && !menuService.getActive()"&ndash;&gt;-->
<!--&lt;!&ndash;    (click)="interfaceService.setHotelOpenGeo(true)"&ndash;&gt;-->
<!--&lt;!&ndash;  >&ndash;&gt;-->
<!--&lt;!&ndash;    <app-icon [icon]="Icons.geoAnchor" [invert]="getInvert()"/>&ndash;&gt;-->
<!--&lt;!&ndash;  </div>&ndash;&gt;-->
<!--&lt;!&ndash;  <div&ndash;&gt;-->
<!--&lt;!&ndash;    class="header-hotels-button"&ndash;&gt;-->
<!--&lt;!&ndash;    style="right: -76px"&ndash;&gt;-->
<!--&lt;!&ndash;    *ngIf="interfaceService.getHotelOpenGeo() && showBackButton('geo') && !menuService.getActive()"&ndash;&gt;-->
<!--&lt;!&ndash;    (click)="interfaceService.setHotelOpenGeo(false)"&ndash;&gt;-->
<!--&lt;!&ndash;  >&ndash;&gt;-->
<!--&lt;!&ndash;    <app-icon [icon]="Icons.crossClose" [invert]="getInvert()"/>&ndash;&gt;-->
<!--&lt;!&ndash;  </div>&ndash;&gt;-->
<!--&lt;!&ndash;  <div&ndash;&gt;-->
<!--&lt;!&ndash;    class="header-hotels-button"&ndash;&gt;-->
<!--&lt;!&ndash;    style="right: -70px"&ndash;&gt;-->
<!--&lt;!&ndash;    *ngIf="showBackButton('map')"&ndash;&gt;-->
<!--&lt;!&ndash;    (click)="openMap()"&ndash;&gt;-->
<!--&lt;!&ndash;  >&ndash;&gt;-->
<!--&lt;!&ndash;    <app-icon [icon]="Icons.mapMob" [invert]="getInvert()"/>&ndash;&gt;-->
<!--&lt;!&ndash;  </div>&ndash;&gt;-->
<!--  <div class="header-mob-el-container header-mob-el-container-another" *ngIf="menuService.getActive()">-->
<!--    <app-icon-->
<!--      [icon]="Icons.airplane"-->
<!--      [invert]="getInvert()"-->
<!--      (click)="menuService.setMobileOverlay(!menuService.getMobileOverlay())"-->
<!--      class="header-mob-el-button"-->
<!--    />-->
<!--    <app-texts-->
<!--      [texts]="[-->
<!--                {text: ['Рус', 'Eng']}-->
<!--              ]"-->
<!--      (click)="localizationService.setLanguage()"-->
<!--      class="mx-3 header-text-button"-->
<!--    />-->
<!--    <app-icon-->
<!--      class="mx-3"-->
<!--      [icon]="Icons.theme"-->
<!--      [invert]="!getInvert()"-->
<!--      (click)="themeService.changeTheme()"-->
<!--      class="header-mob-el-button"-->
<!--    />-->
<!--&lt;!&ndash;    <app-icon class="mx-3" [icon]="Icons.hamburger" (click)="menuList()" [invert]="getInvert()"/>&ndash;&gt;-->
<!--    <app-icon-->
<!--      class="mx-3"-->
<!--      [icon]="Icons.crossClose"-->
<!--      [invert]="getInvert()"-->
<!--      (click)="menuService.setActive()"-->
<!--      class="header-mob-el-button"-->
<!--    />-->
<!--  </div>-->
<!--</div>-->
<app-new-mobile-header *ngIf="menuService.getMobileStyle() !== 'none'"/>
<app-new-mobile-menu *ngIf="menuService.getMobileActive()"/>
